var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var SidebarList = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Roboto', sans-serif;\n  a {\n    display: block;\n    text-decoration: none;\n    line-height: 42px;\n    margin-left: 25px;\n  }\n\n  .sidebar-link--icon {\n    position: relative;\n    top: 0;\n    width: 20px;\n  }\n\n  .title {\n    color: #c03;\n    font-size: 15px;\n    font-weight: 500;\n  }\n"], ["\n  font-family: 'Roboto', sans-serif;\n  a {\n    display: block;\n    text-decoration: none;\n    line-height: 42px;\n    margin-left: 25px;\n  }\n\n  .sidebar-link--icon {\n    position: relative;\n    top: 0;\n    width: 20px;\n  }\n\n  .title {\n    color: #c03;\n    font-size: 15px;\n    font-weight: 500;\n  }\n"])));
export var Link = React.forwardRef(function (_a, ref) {
    var href = _a.href, title = _a.title, media = _a.media, props = __rest(_a, ["href", "title", "media"]);
    return href ? (React.createElement(SidebarList, { className: "sidebar-link" },
        React.createElement("a", __assign({ ref: ref, href: href }, props),
            media && React.createElement("img", { src: media, className: "sidebar-link--icon" }),
            React.createElement("span", { className: "title" }, title)))) : (React.createElement(SidebarList, { className: "sidebar-link" },
        React.createElement("a", __assign({ ref: ref }, props),
            media && React.createElement("img", { src: media, className: "sidebar-link--icon mr-2" }),
            React.createElement("span", null, title))));
});
var templateObject_1;
